import React from 'react';

const Svg = ({ children }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {children}
  </svg>
);

const stroke = {
  stroke: 'currentColor',
  strokeWidth: '1.6',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const CupsIcon = () => (
  <Svg>
    <path
      d="M6.2 3.2h7.6v3.4c0 2.1-1.7 3.8-3.8 3.8S6.2 8.7 6.2 6.6V3.2z"
      {...stroke}
    />
    <path d="M6.2 4.4H4.4A2.2 2.2 0 006.6 6.6" {...stroke} />
    <path d="M13.8 4.4h1.8A2.2 2.2 0 0113.4 6.6" {...stroke} />
    <path d="M10 10.4v2.4M7.6 16.8h4.8M10 12.8v4" {...stroke} />
  </Svg>
);

export const ApplyIcon = () => (
  <Svg>
    <path d="M6 3.4h5.2L15.6 8v8.6H6V3.4z" {...stroke} />
    <path d="M11.2 3.4V8h4.4" {...stroke} />
    <path d="M8.4 11.2h4.8M8.4 13.8h3.2" {...stroke} />
  </Svg>
);

export const RankingIcon = () => (
  <Svg>
    <path d="M3.4 14.6h3.2V8.8H3.4v5.8zM8.4 14.6h3.2V5.4H8.4v9.2zM13.4 14.6h3.2v-3.6h-3.2v3.6z" {...stroke} />
  </Svg>
);

export const ArchiveIcon = () => (
  <Svg>
    <path d="M3.4 5.2h13.2v2.4H3.4V5.2z" {...stroke} />
    <path d="M4.4 7.6h11.2v7.8H4.4V7.6z" {...stroke} />
    <path d="M8.4 10.6h3.2" {...stroke} />
  </Svg>
);

export const TipsIcon = () => (
  <Svg>
    <path
      d="M10 3.4a4.6 4.6 0 00-2.4 8.5c.5.3.8.8.8 1.4v.3h3.2v-.3c0-.6.3-1.1.8-1.4A4.6 4.6 0 0010 3.4z"
      {...stroke}
    />
    <path d="M8.4 15.4h3.2M8.8 17h2.4" {...stroke} />
  </Svg>
);

export const LeaguesIcon = () => (
  <Svg>
    <circle cx="10" cy="6.6" r="3.2" {...stroke} />
    <path d="M6.4 16.6l1-5.2 2.6 1.8 2.6-1.8 1 5.2H6.4z" {...stroke} />
  </Svg>
);

export const TrackIcon = () => (
  <Svg>
    <circle cx="8.6" cy="8.6" r="4.2" {...stroke} />
    <path d="M11.7 11.7L16.2 16.2" {...stroke} />
  </Svg>
);

const ICONS = {
  cups: CupsIcon,
  apply: ApplyIcon,
  ranking: RankingIcon,
  archive: ArchiveIcon,
  tips: TipsIcon,
  leagues: LeaguesIcon,
  track: TrackIcon,
};

export default function HubLinkIcon({ name }) {
  const Icon = ICONS[name] || CupsIcon;
  return <Icon />;
}
